import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../srcCommon/helpers/reselectHelpers';
import {CalendarTypesEnum, InterfaceEventsEnum, trackInterfaceEvent} from '../../services/tracking';
import {getHasNoCalendars} from '../../store/data/calendarVersions/calendarVersionsSelectors';
import {getCalendars} from '../../store/data/dataSelectors';
import {
  createOrUpdateCalendarEventDraftAction,
  focusCalendarEventAction,
  navigateCalendarsAction,
  popoutSideCalendarsAction,
} from '../../store/panels/calendars/calendarsPanelActions';
import {
  makeGetCalendarEventData,
  makeGetCalendarsPanel,
} from '../../store/panels/calendars/calendarsPanelSelectors';
import {CalendarEventGridParameters} from '../../store/panels/calendars/calendarsPanelState';
import {CalendarsViewTypesEnum} from '../../store/panels/calendars/calendarsParameters';
import {CalendarsPanelId} from '../../store/panels/panelStateBase';
import {inLegacyTransientPanel} from '../legacyTransientPanel';
import {SideCalendars} from './sideCalendars';

/*
 * Props.
 */

interface SideCalendarsContainerProps {
  panelId: CalendarsPanelId;
}

/*
 * Selectors.
 */

function makeGetFocusedCalendarEventParameters(getCalendarsPanel: ReturnType<typeof makeGetCalendarsPanel>) {
  return createSelector([getCalendarsPanel], (panel) => panel.focusedCalendarEventParameters);
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SideCalendarsContainerProps>()(() => {
  const getCalendarsPanel = makeGetCalendarsPanel();
  const getFocusedCalendarEventParameters = makeGetFocusedCalendarEventParameters(getCalendarsPanel);
  const getFocusedCalendarEventData = makeGetCalendarEventData(getFocusedCalendarEventParameters);

  return {
    calendars: getCalendars,
    hasNoCalendars: getHasNoCalendars,
    focusedCalendarEventData: getFocusedCalendarEventData,
  };
});

const mapDispatchToProps = makeMapDispatchToProps<SideCalendarsContainerProps>()(({panelId}) => ({
  onCreateEventClick: () => createOrUpdateCalendarEventDraftAction(panelId),
  onPopoutClick: () => popoutSideCalendarsAction(panelId),
  onEventClick: (parameters: CalendarEventGridParameters) => {
    trackInterfaceEvent(InterfaceEventsEnum.CLICK_CALENDAR_EVENT, {
      calendar_type: CalendarTypesEnum.SIDE,
    });
    return focusCalendarEventAction(panelId, parameters);
  },
}));

export const SideCalendarsContainer = inLegacyTransientPanel(
  connect(mapStateToProps, mapDispatchToProps)(SideCalendars),
  ({panelId}) => navigateCalendarsAction(panelId, {viewType: CalendarsViewTypesEnum.DAY}),
);
